import { render, staticRenderFns } from "./QuestionSetController.vue?vue&type=template&id=525bbc03"
import script from "./QuestionSetController.vue?vue&type=script&lang=js"
export * from "./QuestionSetController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports